import { supabase } from './supabase'

export interface WorkActivity {
  id: string
  agent_id: string
  task: string
  model: string | null
  checkin_date: string
  created_at: string
  activity_kind: 'activity' | 'completed_work'
  classification?: string | null
  summary_status?: 'ready' | 'pending' | 'unavailable' | null
  summary_attempts?: number | null
  summary_last_attempt_at?: string | null
  summary_error?: string | null
  total_count: number
}

export function activityDateRange(from: string | null, to: string | null) {
  const valid = (date: string | null): date is string => !!date && /^\d{4}-\d{2}-\d{2}$/.test(date)
    && !Number.isNaN(Date.parse(date)) && new Date(date).toISOString().slice(0, 10) === date
  return valid(from) && valid(to) && from <= to ? { from, to } : null
}

// The RPC caps each page at 100 even when callers request more.
export async function fetchAgentActivity<T extends WorkActivity>(teamId: string, agentId: string, from: string, to: string): Promise<T[]> {
  const rows: T[] = []
  for (let page = 0; ; page += 1) {
    const { data, error } = await (supabase.rpc as any)('get_agent_activity', {
      p_team_id: teamId, p_agent_id: agentId, p_from: from, p_to: to,
      p_page_size: 100, p_page: page,
    })
    if (error) throw error
    const batch = (data ?? []) as T[]
    rows.push(...batch)
    if (batch.length < 100 || rows.length >= Number(batch[0]?.total_count ?? rows.length)) return rows
  }
}
